import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { makeStyles } from '@material-ui/core/styles'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import { Card, Dialog, Menu, MenuItem, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import Badge from '../Badge/Badge'
import WorkIcon from '@material-ui/icons/Work'
import WatchLaterIcon from '@material-ui/icons/WatchLater'
import { format, parse } from 'date-fns'
import { fr } from 'date-fns/locale'
import CloseIcon from '@material-ui/icons/Close'
import Box from '@mui/material/Box'
import CheckIcon from '@material-ui/icons/Check'
import PhoneIcon from '@material-ui/icons/Phone'
import allActions from "../../redux/actions/user";
import {useDispatch, useSelector} from "react-redux";

const useStyles = makeStyles(theme =>({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    backgroundColor: '#FFF',
    padding: '16px 12px',
    borderRadius: 12,
    maxWidth: 550,

    [theme.breakpoints.down('550')]: {
      width: 'auto'
    }
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,

    [theme.breakpoints.down('550')]: {
      flexDirection: 'column',
      '& > button':{
        width: '100%',
      },
    },

    '& > div': {
      flexWrap: 'wrap',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
    }
  },
  title: {
    color: '#000',
    fontWeight: 'bolder !important',
  },
  more: {
    color: '#98A2AE !important',
    padding: '3px 6px !important',
    minWidth: 'unset !important',
    backgroundColor: '#E8EBED !important',
    '&:hover': {
      backgroundColor: '#d9dadb !important',
    }
  },
  activities: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 16,
  },
  cardDialog: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  btnGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 16,
  }
}))

export default function CardAppointment({ appointment: { id, title, date, location, activites, isHistory=false } }) {
  const user = useSelector(state => state.user)
  const dispatch = useDispatch()

  const classes = useStyles()
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const [openCancelNotPossible, setOpenCancelNotPossible] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('550'))

  function parseDateHour(dateStr) {
    const date = parse(dateStr, 'dd/MM/yyyy HH:mm', new Date(), { locale: fr })

    return format(date, 'HH:mm', { locale: fr })
  }

  function parseDate(dateStr) {
    const date = parse(dateStr, 'dd/MM/yyyy HH:mm', new Date(), { locale: fr })
    console.log(dateStr)
    console.log(date)

    return format(date, 'dd MMMM yyyy', { locale: fr })
  }

  function handleCancel() {
    const todayDate = new Date()
    const appointmentDate = parse(date, 'dd/MM/yyyy HH:mm', new Date(), { locale: fr })

    if (todayDate > appointmentDate) {
      console.log('cannot cancel appointment')
      return
    }

    const isAppointmentDateUnder24h = appointmentDate - todayDate < 24 * 60 * 60 * 1000

    if (isAppointmentDateUnder24h) {
      setOpen(false)
      setOpenCancelNotPossible(true)
    } else {
      setOpen(true)
      setOpenCancelNotPossible(false)
    }
  }

  function handleCallCenter() {
    const phoneNumber = '+1234567890'
    window.location.href = `tel:${phoneNumber}`
  }

  async function handleConfirmDialog() {
    setOpen(false)
    console.log('cancel appointment')

    dispatch(allActions.setLoading(true))
    // Call API to cancel appointment
    const result = await allActions.fetchPostAPI(`api/planning/cancel-booking-fo`, {
      idCreneau: id,
      idLicencie: user?.id
    })

    if (result?.res?.status === 200) {
      dispatch(allActions.setLoading(false))
      window.location.reload()
    }
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <Dialog open={openCancelNotPossible} onClose={() => setOpenCancelNotPossible(false)}>
        <Card variant="outlined" sx={{ padding: 2 }} className={classes.cardDialog}>
          <Typography variant="h6">Annulation impossible</Typography>
          <Typography>
            Pour annuler votre prise de rendez-vous, veuillez contacter le centre.<br/>
            Veuillez noter que l'annulation n'est pas possible, car la demande doit être effectuée au moins 24 heures avant la date prévue du rendez-vous.
          </Typography>
          <Box className={classes.btnGroup}>
            <Button
              variant="contained"
              color="error"
              onClick={() => setOpenCancelNotPossible(false)}
              startIcon={<CloseIcon />}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCallCenter}
              startIcon={<PhoneIcon />}
            >
              Contacter
            </Button>
          </Box>
        </Card>
      </Dialog>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <Card variant="outlined" sx={{ padding: 2 }} className={classes.cardDialog}>
          <Typography variant="h6">Confirmation annulation</Typography>
          <Typography>
            Voulez-vous vraiment annuler votre rendez-vous ?
          </Typography>
          <Box className={classes.btnGroup}>
            <Button
              variant="contained"
              color="error"
              onClick={() => setOpen(false)}
              startIcon={<CloseIcon />}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleConfirmDialog}
              startIcon={<CheckIcon />}
            >
              Confirmer
            </Button>
          </Box>
        </Card>
      </Dialog>
      <div className={classes.root}>
        <div className={classes.containerTitle}>
          <div>
            <EventAvailableIcon />
            <Typography variant="h5" component="h2" className={classes.title}>
              {title}
            </Typography>
          </div>
          <Button disableElevation className={classes.more} variant="contained" onClick={handleClick}>
            {isSmallScreen ? 'Plus d\'actions' : <MoreHorizIcon width={20} height={20} style={{ color: '#98A2AE' }} />}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>...</MenuItem>
          </Menu>
        </div>
        {activites?.length > 0 ? <>
          <Typography variant="body1" component="h5" style={{ textAlign: 'start', color: '#ABABAB' }} >
            Inscription pour les activités suivantes :
          </Typography>
          <div className={classes.activities}>
            {activites?.map((activity, index) => (
              <Badge key={index} value={activity} color={'#2196F3'} style={{ fontWeight: '400', fontSize: '13px', lineHeight:1 }} />
            ))}
          </div>
        </> : <Typography variant="body1" component="h5" style={{ textAlign: 'start', color: '#ABABAB' }} >
          Aucune activité sélectionnée
        </Typography>}
        <div className={classes.containerTitle}>
          <div>
            <BadgeCardAppointment icon={<WorkIcon />} text={location+', '+parseDate(date)} />
            <BadgeCardAppointment icon={<WatchLaterIcon />} text={parseDateHour(date)} />
          </div>
          <Button disableElevation style={{display: isHistory ? 'none' : ''}} variant="contained" color="error" onClick={() => handleCancel()} startIcon={<CloseIcon />}>
            Annuler
          </Button>
        </div>
      </div>
    </>
  )
}

function BadgeCardAppointment ({ icon, text }) {
  const useStyles = makeStyles(theme=>({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      backgroundColor: '#F0EEFF',
      color: '#755EEE !important',
      padding: '8px 12px',
      width: 'fit-content',

      [theme.breakpoints.down('550')]: {
        width: '100%',
      }
    }
  }))

  const classes = useStyles()

  return (
    <div className={classes.root}>
      {icon}
      <Typography variant="body2" component="h5" style={{ fontWeight: 500, fontSize: '1rem'  }}>
        {text}
      </Typography>
    </div>
  )
}
